<template>
  <b-container class="p-0" style="text-align: center">
    <b-row style="padding-left: 30px">
      <b-col cols="auto" v-if="imageUrl" @click="showImagePreview">
        <ImageViewer
            :src="imageUrlThumpnail"
            :min-height="40"
            :max-height="50"
            :min-width="40"
            :max-width="50"
        >
        </ImageViewer>
      </b-col>
      <b-col v-else cols="auto">
      </b-col>
    </b-row>
  </b-container>
</template>

<script>

import ImageViewer from "@/components/img/ImageViewer";
import BudgetingPlannerPM from "@/server/com/silkplm/model/plm/BudgetingPlannerPM";
import DynamicEntity from "@/components/forms/DynamicEntity";
import ActivityManager from "@/activity/ActivityManager";
import _ from "lodash";


let counter = 0;

export default {
  name: "ImageRendererGrid",
  components: {ImageViewer},

  mounted() {
    this.dataId = counter++;
    this.refresh();
  },

  methods: {
    async showImagePreview(){
      if (window.isCordova){
        await DialogManager.imagePreview(window.cordovaUrl + this.imageUrl);
      }else {
        await DialogManager.imagePreview(this.imageUrl);
      }
    },

    async refresh() {
      this.imageUrl = null;

      this.$nextTick(async () => {
        if(!this.model){
          this.imageUrl = "";
        } else if (this.model[this.prop]?.imagesList) {
          for (let image of this.model[this.prop]?.imagesList) {
            if (image.customData && image.customData.imageTagList) {
              for (let tag of image.customData.imageTagList) {
                if (tag.name === "Main Picture") {
                  this.imageUrl = image.url;
                }
              }
            }
          }
          if (this.imageUrl === null) {
            this.imageUrl = this.model[this.prop]?.imagesList[0]?.url;
          }
        } else if (this.model[this.prop]) {
          // TODO usunąć ten if, else zostawić wtedy jak dynamic entities zostaną rozszerzone o eventy, był taki problem, że
          // przy wgraniu piktogramu do wartości na dynamicznych słowniku nie ładował się na liście piktogram, trzeba było odświeżyć
          if (this.model[this.prop] && this.model[this.prop].url === undefined) {
            if (this.prop === "pictogram") {
              let dynamicFormClass = this.column.formConfig.formClassLong;
              let dynamicId = this.model.id;
              let dynamicEntity = await Rpc.Forms.getExtendedDynamicEntity(dynamicFormClass, dynamicId);
              if (dynamicEntity) {
                this.imageUrl = dynamicEntity.pictogram.url;
              }
            }
          } else {
            this.imageUrl = this.model[this.prop].url;
          }
        } else {
          this.imageUrl = "";
        }
        if(this.imageUrl) {
          if (this.imageUrl.includes("?")) {
            this.imageUrlThumpnail = this.imageUrl + "&format=grid";
          } else {
            this.imageUrlThumpnail = this.imageUrl + "?format=grid";
          }
        } else {
          this.imageUrlThumpnail = "";
        }
      });
    }
  },
  watch: {
    model: function (val) {
      this.refresh();
    },
    prop: function (val) {
      this.refresh();
    }
  },
  data: () => ({
    imageUrl: null,
    imageUrlThumpnail: null
  }),
  props: ["rowIndex", "prop", "model", "column"]

};
</script>